import { applyReplacements } from "../Utility/Replacement"

export function scanEditor(editor) {

  if (!editor) return;

     const body = editor.getBody(); 

  if (!body) return;

  const walker = document.createTreeWalker(
    body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  

  let node;

  while ((node = walker.nextNode())) {

    const originalText = node.nodeValue;

    console.log("originalVal", originalText);

    const updatedText = applyReplacements(originalText);

    if (originalText !== updatedText) {
      node.nodeValue = updatedText;
    }

  }
}